import React, { PureComponent } from 'react';
import {
    Text,
    TouchableOpacity,
    View
} from 'react-native-web';
import PropTypes from 'prop-types';

import GLOBAL from '../../configs/config_global';

export default class ModifierGroup extends PureComponent {
    static propTypes = {
        modifierGroupData: PropTypes.object,
        modifierGroupIndex: PropTypes.number,
        onModifierGroupPressed: PropTypes.func,
        customStyle: PropTypes.object
    }

    static defaultProps = {
        modifierGroupData: {},
        modifierGroupIndex: -1,
        onModifierGroupPressed: () => {},
        customStyle: {}
    }

    // region Function - Get Modifier Group Title
    getModifierGroupTitle(item, getMinOnly = false) {
        let title = item.name,
            maxStr = `Max ${item['max_select'] || 1}`,
            minStr = `Min ${item['min_select'] || 1}`;

        // If this group is required
        if (item['must_select'] === 1) {
            title += ' (Required,';
        }
        else title += ' (';

        // Only select one
        if (item['type'] === 0) {
            title += ' Choose 1)';
        }
        // Allow multiple selections
        else {
            // There is a min require
            if (item['must_select']) {
                // Unlimited select
                if (item['max_select'] === 0) {
                    title += ` ${minStr})`;
                }
                // There is max cap
                else title += ` ${minStr} - ${maxStr})`;
            }
            // There is no min
            else {
                // Unlimited select
                if (item['max_select'] !== 0) {
                    title += ` ${maxStr})`;
                }
            }
        }

        if (getMinOnly) {
            return(`${item.name} (${minStr})`);
        }
        else {
            title = title.replace(/\($/, '');
            title = title.replace('( ', '(');
            title = title.trim();
            return title;
        }
    }
    // endregion

    render() {
        let item = this.props.modifierGroupData,
            index = this.props.modifierGroupIndex,
            itemKey = `modifierGroup_${item.id || index}`;

        return(
            <TouchableOpacity
                key={itemKey}
                onPress={this.props.onModifierGroupPressed}
                style={[{ alignSelf: 'stretch', marginTop: index !== 0 ? 16 : 0 }, this.props.customStyle]}>
                {/* Group Title */}
                <Text style={{ fontWeight: '500', color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontSize: 18 }}>
                    {this.getModifierGroupTitle(item)}
                </Text>

                {/* Group Items */}
                {
                    item.items.map((modifierItem, itemIndex) => {
                        let modifierKey = `modifierItem_${modifierItem.id || itemIndex}`,
                            isNegative = Number(modifierItem.price) < 0;

                        return(
                            <View key={modifierKey} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', marginTop: 12 }}>
                                <Text style={{ flex: 1, color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, fontSize: 16 }}>
                                    {modifierItem.name}
                                    {` (${(isNegative ? '-$' : '$') + Math.abs(Number(modifierItem.price)).toFixed(2)})`}
                                </Text>
                            </View>
                        );
                    })
                }
            </TouchableOpacity>
        );
    }
}
